import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import cn from 'classnames';
import { UncontrolledTooltip, Input } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { number, string, object, func, oneOfType } from 'prop-types';
import CustomTable from '../../../../components/CustomTable/CustomTable';
import Icon from '../../../../components/Icon/Icon';
import { FMessage } from '../../../../hoc/IntlComponents';
import CopyContent from '../../../../components/common/CopyContent';
import DateTime from '../../../../components/DateTime/DateTime';
import CustomTableCell from '../../../../components/CustomTable/CustomTableCell';
import SplitTestLabel from "../../../../components/common/SplitTestLabel";
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../../../config';

class FlowListItem extends Component {
  static propTypes = {
    id: number.isRequired,
    site_id: number,
    offer_id: number,
    its: number.isRequired,
    type: oneOfType([string, number]),
    title: string.isRequired,
    offers: object.isRequired,
    sites: object.isRequired,
    onFlowRemove: func.isRequired,
    link: oneOfType([string, object]),
    flow: string,
    split_test: number
  };

  static defaultProps = {
    split_test: 0,
    its: 0,
    offers: {},
    sites: {},
    link: '',
    onFlowRemove() {},
  };

  getOfferName = offerId => {
    const { offers } = this.props;
    return offers[offerId] ? offers[offerId].title : offerId;
  };

  getSiteName = siteId => {
    const { sites } = this.props;
    return sites[siteId] ? (
      sites[siteId].title
    ) : siteId === 0 ? (
      <FMessage id="flows.table.application" />
    ) : (
      siteId
    );
  };

  isDisabled = offerId => {
    const { offers } = this.props;
    return offers && offers[offerId] ? offers[offerId].disabled : false;
  };

  getStreamType = flow => {
    if (flow === 'stream' || flow === 'tds') {
      return <FMessage id={`flows.table.type.${flow}`} />;
    }
    return '';
  };

  renderLink = () => {
    const { encId, link, flow } = this.props;
    if (flow !== 'tds') {
      return link ? (
        <a href={link} target="_blank">
          {encId}
        </a>
      ) : (
        encId
      );
    } else {
      return link && link.host && link.link && link.scheme ? (
        <a href={`${link.scheme}://${link.host}/${link.link}`} target="_blank">
          {link.link}
        </a>
      ) : (
        encId
      );
    }
  };

  getLink = () => {
    const { link, flow } = this.props;
    if (flow !== 'tds') {
      return link ? link : '';
    } else {
      return link && link.host && link.link && link.scheme
        ? `${link.scheme}://${link.host}/${link.link}`
        : '';
    }
  };

  render() {
    const {
      id,
      its,
      title,
      link,
      links = {},
      offer_id: offerId,
      site_id: siteId,
      is_block,
      onFlowRemove,
      flow,
      count,
      split_test
    } = this.props;

    const toolTipPosition = count === 1 ? 'left' : 'top';

    const { directLinkWithOutRedirect, directLinkLanding } = links;

    return (
      <CustomTable.Row className={cn('flows-list-item', { disabled: this.isDisabled(offerId) })}>
        <CustomTable.Cell>{this.renderLink()}</CustomTable.Cell>
        {link ? (
          <CustomTable.Cell className="text-center">
            {/* <CopyContent
              content={this.getLink()}
              iconType='copy'
              copyMessageId='flows.table.click-link'
              tooltipMessageId='flows.table.referral'
              tooltipTargetId={`flow_link_${id}`}
            /> */}
            <Input
              bsSize="sm"
              size="sm"
              readOnly
              value={this.getLink()}
              onClick={e => e.target.select()}
            />
          </CustomTable.Cell>
        ) : (
          <CustomTable.Cell />
        )}

        <CustomTableCell>
          {directLinkWithOutRedirect && (
            <Input
              bsSize="sm"
              size="sm"
              className="mt-1"
              readOnly
              value={directLinkWithOutRedirect}
              onClick={e => e.target.select()}
            />
          )}
          {directLinkLanding ? (
            <Input
              bsSize="sm"
              size="sm"
              className="mt-1"
              readOnly
              value={directLinkLanding}
              onClick={e => e.target.select()}
            />
          ) : null}
        </CustomTableCell>

        <CustomTable.Cell>
          <DateTime theme={4} timestamp={its} format="DD/MM/YYYY" withDateTime />
        </CustomTable.Cell>

        <CustomTable.Cell>{title}</CustomTable.Cell>
        {/* 
        <CustomTable.Cell>{this.getStreamType(flow)}</CustomTable.Cell> */}

        {siteId || siteId === 0 ? (
          <CustomTable.Cell>
            <Link to={`/offers/${offerId}`}>{this.getOfferName(offerId)}</Link>
          </CustomTable.Cell>
        ) : (
          <CustomTable.Cell />
        )}

        {/* {siteId ? <CustomTable.Cell>{this.getSiteName(siteId)}</CustomTable.Cell> : <CustomTable.Cell />} */}

        <CustomTable.Cell>
          <ul className="flow-statuses list-inline no-margin">
            {this.isDisabled(offerId) && (
              <li className="list-inline-item">
                <Icon id={`blocked_offer_${id}`} type="warning" />

                <UncontrolledTooltip
                  placement={toolTipPosition}
                  trigger="legacy hover"
                  modifiers={{
                    offset: {
                      offset: '0, 5px',
                    },
                  }}
                  target={`blocked_offer_${id}`}
                >
                  <FormattedMessage
                    id="flows.table.offer-disabled"
                    defaultValue="Offer disabled! Please redirect your traffic to another offer!"
                  />
                </UncontrolledTooltip>
              </li>
            )}

            {is_block > 0 && (
              <li className="list-inline-item">
                <Icon id={`blocked_flow_${id}`} type="lock" />

                <UncontrolledTooltip
                  placement={toolTipPosition}
                  trigger="legacy hover"
                  modifiers={{
                    offset: {
                      offset: '0, 5px',
                    },
                  }}
                  target={`blocked_flow_${id}`}
                >
                  <FormattedMessage id="flows.table.locked" defaultValue="Flow is blocked!" />
                </UncontrolledTooltip>
              </li>
            )}

            {(split_test > 0) &&
              <li className="list-inline-item">
                <SplitTestLabel style={{marginBottom: '3px'}} tooltipPlacement='top' tooltipTargetId={`flow_split_test_label_${id}`}/>
              </li>
            }
          </ul>
        </CustomTable.Cell>

        <CustomTable.Cell className="table-controls" style={{textAlign: 'end'}}>
          <Link Link
            to={`/statistics?flows=${id}`}
            role="button"
            className="flow-control edit-flow"
            id={`flow_stats_${id}`}
          >
            <SVG
              src={`${STATIC_PATH}/img/action-icons/flow_statistics.svg`}
              height="15"
              width="16"
              cacheRequests
            />
          </Link>
          <UncontrolledTooltip
            placement={toolTipPosition}
            trigger="legacy hover"
            modifiers={{
              offset: {
                offset: '0, 5px',
              },
            }}
            target={`flow_stats_${id}`}
          >
            <FMessage id="flows.table.flow_stats" />
          </UncontrolledTooltip>
          <Link
            id={`edit_flow_${id}`}
            to={flow === 'tds' ? `/tools/streams/tds/${id}` : `/tools/flows/${id}`}
            className="flow-control edit-flow"
            role="button"
            aria-label="Edit Flow"
          >
            <Icon type="edit" />
          </Link>
          <UncontrolledTooltip
            placement={toolTipPosition}
            trigger="legacy hover"
            modifiers={{
              offset: {
                offset: '0, 5px',
              },
            }}
            target={`edit_flow_${id}`}
          >
            <FMessage id="flow.title.edit" />
          </UncontrolledTooltip>
          <a
            id={`remove_flow_${id}`}
            className="flow-control remove-flow"
            role="button"
            aria-label="Remove Flow"
            onClick={() => onFlowRemove(id)}
          >
            <Icon type="trash" />
          </a>
          <UncontrolledTooltip
            placement={toolTipPosition}
            trigger="legacy hover"
            modifiers={{
              offset: {
                offset: '0, 5px',
              },
            }}
            target={`remove_flow_${id}`}
          >
            <FMessage id="flow.title.remove" />
          </UncontrolledTooltip>
        </CustomTable.Cell>
      </CustomTable.Row>
    );
  }
}

const mapStateToProps = ({ streams }) => ({
  offers: streams.settings.offers,
  sites: streams.settings.sites,
});

export default connect(mapStateToProps)(FlowListItem);
